import Main from '../../pages/Main.vue';
import PageName from '../../constant/PageName';
import PermissionIds from '../../constant/PermissionIds';
// 作为Main组件的子页面展示并且在左侧菜单显示的路由写在appRouter里
export const appRouter = [
  {
    path: '/basicData',
    icon: 'md-list',
    name: 'basicData',
    title: '基础数据',
    component: Main,
    children: [
      /** 考题管理部分 **/
      {
        path: 'questionManage',
        title: '考题管理',
        name: PageName.PAGE_BASICDATA_QUESTIONMANAGE,
        permissionId:PermissionIds.PERMISSION_BASICDATA_QUESTIONMANAGE,
        component: function(resolve) { require(['../../pages/basicData/questionManage/QuestionManage.vue'], resolve) },
      },	
      /** 新闻管理部分 **/
      {
        path: 'news',
        title: '新闻管理',
        name: PageName.PAGE_BASICDATA_NEWS,
        permissionId:PermissionIds.PERMISSION_BASICDATA_NEWS,
        component: function(resolve) { require(['../../pages/basicData/news/News.vue'], resolve) },
      },
      /** 宣传图部分 **/
      {
        path: 'propagateImg',
        title: '宣传图',
        name: PageName.PAGE_BASICDATA_PROPAGATEIMG,
        permissionId:PermissionIds.PERMISSION_SYSTEM_PROPAGATEIMG,
        component: function (resolve) { require(['../../pages/basicData/propagateImg/PropagateImg.vue'], resolve) },
      },
      /** 回收价格 **/
      {
        path: 'recoveryPrice',
        title: '回收价格',
        name: PageName.PAGE_BASICDATA_RECOVERYPRICE,
        permissionId:PermissionIds.PERMISSION_SYSTEM_RECOVERYPRICE,
        component: function (resolve) { require(['../../pages/basicData/recoveryPrice/RecoveryPrice.vue'], resolve) },
      },
       /** 用户缴费积分配置部分 **/
       {
        path: 'paymentScoreConfig',
        title: '用户缴费积分配置',
        name: PageName.PAGE_BASICDATA_PAYMENTSCORECONFIG,
        permissionId:PermissionIds.PERMISSION_BASICDATA_PAYMENTSCORECONFIG,
        component: function (resolve) { require(['../../pages/basicData/paymentScoreConfig/PaymentScoreConfig.vue'], resolve) },
      },
      /** 易腐垃圾回收设备部分 **/
      {
        path: 'rotGarbageCapacity',
        title: '易腐垃圾回收设备',
        name: PageName.PAGE_BASICDATA_ROTGARBAGECAPACITY,
        permissionId:PermissionIds.PERMISSION_BASICDATA_ROTGARBAGECAPACITY,
        component: function (resolve) { require(['../../pages/basicData/rotGarbageCapacity/RotGarbageCapacity.vue'], resolve) },
      },
      /** 商品管理部分 **/
      {
        path: 'goodsManage',
        title: '商品管理',
        name: PageName.PAGE_BASICDATA_GOODSMANAGE,
        permissionId:PermissionIds.PERMISSION_BASICDATA_GOODSMANAGE,
        component: function (resolve) { require(['../../pages/basicData/goodsManage/GoodsManage.vue'], resolve) },
      },
       /** 活动配置部分 **/
       {
        path: 'purchaseActivities',
        title: '活动配置',
        name: PageName.PAGE_BASICDATA_PURCHASEACTIVITIES,
        permissionId:PermissionIds.PERMISSION_BASICDATA_PURCHASEACTIVITIES,
        component: function (resolve) { require(['../../pages/basicData/purchaseActivities/PurchaseActivities.vue'], resolve) },
      },
      /** 回收站点管理部分 **/
      {
        path: 'recycleSite',
        title: '回收站点管理',
        name: PageName.PAGE_BASICDATA_RECYCLESITE,
        permissionId:PermissionIds.PERMISSION_BASICDATA_RECYCLESITE,
        component: function (resolve) { require(['../../pages/basicData/recycleSite/RecycleSite.vue'], resolve) },
      },
      /** 自查机构管理部分 **/
      {
            path: 'organRelate',
            title: '自查机构管理',
            name: PageName.PAGE_BASICDATA_ORGANRELATE,
            permissionId:PermissionIds.PERMISSION_BASICDATA_ORGANRELATE,
            component: function(resolve) { require(['../../pages/basicData/organRelate/OrganRelate.vue'], resolve) },
         },	
       /** 评星计划管理部分 **/
       {
        path: 'starsPlanManage',
        title: '评星计划管理',
        name: PageName.PAGE_BASICDATA_STARSPLANMANAGE,
        permissionId:PermissionIds.PERMISSION_BASICDATA_STARSPLANMANAGE,
        component: function (resolve) { require(['../../pages/basicData/starsPlanManage/StarsPlanManage.vue'], resolve) },
      },
      /** 银行卡管理部分 **/
      {
        path: 'bankCardManage',
        title: '银行卡管理',
        name: PageName.PAGE_TRADEMANAGE_BANKCARDMANAGE,
        permissionId:PermissionIds.PERMISSION_TRADEMANAGE_BANKCARDMANAGE,
        component: function (resolve) { require(['../../pages/tradeManage/bankCardManage/BankCardManage.vue'], resolve) },
      },
      /** 数据字典部分 **/
      {
        path: 'dictionary',
        title: '数据字典',
        name: PageName.PAGE_BASICDATA_DICTIONARY,
        permissionId:PermissionIds.PERMISSION_BASICDATA_DICTIONARY,
        component: function (resolve) { require(['../../pages/basicData/dictionary/Dictionary.vue'], resolve) },
      },
      /** 评星项管理部分 **/
      {
        path: 'starTypeManage',
        title: '评星项管理',
        name: PageName.PAGE_BASICDATA_STARTYPEMANAGE,
        permissionId:PermissionIds.PERMISSION_BASICDATA_STARTYPEMANAGE,
        component: function (resolve) { require(['../../pages/basicData/starTypeManage/StarTypeManage.vue'], resolve) },
      },
      /** 行业配置管理部分 **/
      {
        path: 'sectorAllocation',
        title: '行业配置管理',
        name: PageName.PAGE_BASICDATA_SECTORALLOCATION,
        permissionId:PermissionIds.PERMISSION_BASICDATA_SECTORALLOCATION,
        component: function (resolve) { require(['../../pages/basicData/sectorAllocation/SectorAllocation.vue'], resolve) },
      },
      /** 奖励积分 **/
      {
        path: 'BonusPoints',
        title: '奖励积分',
        name: PageName.PAGE_BASICDATA_BONUSPOINTS,
        permissionId:PermissionIds.PERMISSION_BASICDATA_BONUSPOINTS,
        component: function (resolve) { require(['../../pages/basicData/bonusPoints/BonusPoints.vue'], resolve) },
      },
      /** 工作人员联系表部分 **/
      {
        path: 'workContact',
        title: '工作人员联系表',
        name: PageName.PAGE_BASICDATA_WORKCONTACT,
        permissionId:PermissionIds.PERMISSION_BASICDATA_WORKCONTACT,
        component: function (resolve) { require(['../../pages/basicData/workContact/WorkContact.vue'], resolve) },
      },
      
    ]
  },


];

// 作为Main组件的子页面展示但是不在左侧菜单显示的路由写在otherRouter里
export const otherRouter = {
  path: '/',
  name: 'otherRouter',
  title: '首页',
  redirect: '/home',
  component: Main,
  children: [
    // { path: '/system/banner/add', title: '新增轮播图', name: PageName.PAGE_SYSTEM_BANNER_ADD, component: function(resolve) { require(['../../pages/system/banner/banner_add.vue'], resolve)} },
    // { path: '/system/banner/update', title: '修改轮播图', name: PageName.PAGE_SYSTEM_BANNER_UPDATE, component: function(resolve) { require(['../../pages/system/banner/banner_update.vue'], resolve)} },
    { path: '/basicData/recycleSite/RecycleSiteMap', title: '编辑回收站点', name: PageName.PAGE_BASICDATA_RECYCLESITE_MAP, component: function (resolve) { require(['../../pages/basicData/recycleSite/RecycleSiteMap.vue'], resolve) } },
    { path: '/basicData/recycleSite/SiteMap', title: '编辑回收站点', name: PageName.PAGE_BASICDATA_SITE_MAP, component: function (resolve) { require(['../../pages/basicData/recycleSite/SiteMap.vue'], resolve) } },
    { path: '/basicData/news/add', title: '新增新闻', name: PageName.PAGE_BASICDATA_NEWS_ADD, component: function(resolve) { require(['../../pages/basicData/news/NewsAdd.vue'], resolve)} },
		{ path: '/basicData/news/update', title: '修改新闻', name: PageName.PAGE_BASICDATA_NEWS_UPDATE, component: function(resolve) { require(['../../pages/basicData/news/NewsUpdate.vue'], resolve)} },
		{ path: '/basicData/questionManage/add', title: '新增考题', name: PageName.PAGE_BASICDATA_QUESTIONMANAGE_ADD, component: function(resolve) { require(['../../pages/basicData/questionManage/QuestionManageAdd.vue'], resolve)} },
		{ path: '/basicData/questionManage/update', title: '修改考题', name: PageName.PAGE_BASICDATA_QUESTIONMANAGE_UPDATE, component: function(resolve) { require(['../../pages/basicData/questionManage/QuestionManageUpdate.vue'], resolve)} },
	
  ]
};



// WEBPACK FOOTER //
// ./src/router/routers/E_BasicDataRouter.js